const themestyle = {
  colors: {
    primary: "#071833",
    secondary: "#43A047",
    success:"#00B77F",
    tertiary: "#222222",
    white: "#FFFFFF",
    black: "#000000",
    textSecondary: "#8A95A6",
    textMuted: "#8E919A",
    primarybackground: "#F9FAFC",
    border: "#e0e0e0",
    error: "#E74C3C",
    link: "#3289ED",
    textPrimary: "#333333",
    activeGreen: "#6CBC44",
    GRAY_DISABLED: "#9E9E9E",
    lightGreenBg: "#F1F8EE",
    uploadBorder: "#8BC34A",
    uploadBg: "#FAFAFA",
    buttonGreen: "#7BC043",
    buttonGreenHover: "#6FB13E",
    bordercolor:"#E5E7EB"

  },
  fontSizes: {
    small: "18px",
    medium: "24px",
    slarge: "36px",
    large: "32px",
    xlarge: "41px",
    xxlarge: "48px",
  },
  fontFamily: {
    Poppins: "poppins",
    Roboto: "roboto",
  },
  fontWeight: {
    light: 400,
    regular: 500,
    semiBold: 600,
    bold: 700,
  },
  spacing: {
    small: "10px",
    medium: "20px",
    large: "30px",
    xlarge: "40px",
  },
  borderRadius: "100px",
};

export default themestyle;
